export const API_URL = process.env.REACT_APP_API_URL;
export const HOME_URL = process.env.REACT_APP_HOME_URL;
